<template>
  <section class="section">
    <div class="container" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> {{ selectedEventName }}</span>
        </div>
          
      </div>
      <b-tabs v-model="activeTab" >
        <b-tab-item label="ລາຍການງານ/ Event" >
          <table class="table is-fullwidth is-narrow is-small" >
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  ລຳດັບ
                </th>
                <th class="has-text-left " width="40%">
                  ຊື່ງານ/ Event
                </th>
                
                <th class="has-text-centered " width="20%">
                  ລາຍລະອຽດ
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in eventList"
                :key="data.ID"
              >
                <td class="has-text-left ">
                  {{ index +1 }}
                </td>
                <td class="has-text-left ">
                  {{ data.NAME }}
                </td> 
                <td class="has-text-centered ">
                  <b-field>
                    <b-button class="btn-group-margin is-fullwidth"
                          type="is-success"  
                          size="is-small"
                          @click="registerForm(data)"
                          >  <span > ລົງທະບຽນ</span>
                    </b-button>
                    <b-button class="btn-group-margin is-fullwidth"
                        type="is-info"  
                        size="is-small"
                        @click="getEventDetail(data)"
                        >  <span > ຕິດຕາມ</span>
                    </b-button>
                    
                  </b-field>
                    
              </td> 
                
              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        <b-tab-item label="ຟອມລົງທະບຽນເຂົ້າຮ່ວມງານ" style="">

          <div class="columns" >
            <div class="column">
              <div class="columns" >
                <div class="column">
                  <b-field label="ຄົ້ນຫາເບີໂທ">
                    <b-input
                      v-model.trim="regsiterByPhoneno"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-button  style="margin-top: 30px;"
                        class="btn-group-margin"
                        type="is-success"  
                        @click="searchRegsiterByPhoneno"
                        >  <span > ຄົ້ນຫາ</span>
                    </b-button>
                </div>
              </div>
            </div>
          </div>

          <div class="columns" v-if="phoneNoEventList.length > 0">
            
            <div class="column">
              ຜົນການຄົ້ນຫາ
              <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                    <th class="has-text-left " width="2%">
                      ລຳດັບ
                    </th>
                    <th class="has-text-left " width="40%">
                      ລາຍລະອຽດ
                    </th>
                    
                    <th class="has-text-centered " width="20%">
                      ເຂົ້າຮ່ວມງານ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in phoneNoEventList"
                    :key="data.ID"
                  >
                    <td class="has-text-left ">
                      {{ index +1 }}
                    </td>
                    <td class="has-text-left ">
                      {{ data.EVENTID }} <br>
                      {{ data.PHONENO }} <br> 
                      {{ data.FULLNAME }}  <br> 
                      {{ data.EVENTNAME}} 
                    </td> 
                    <td class="has-text-centered ">
                      <b-field v-if="selectedEventID === data.EVENTID" style="color: red;">  
                        ເຂົ້າຮ່ວມງານນີ້ແລ້ວ
                      </b-field>
                      <b-field v-else-if="countThisEvent > 0" style="color: red;">  
                        ----
                      </b-field>
                      <b-filed v-else>
                        <b-button  
                          class="btn-group-margin is-fullwidth"
                          type="is-success"  
                          @click="doregister(2, data.REGISTERID)"
                          >  <span > ເຂົ້າຮ່ວມງານ {{ selectedEventName }}</span>
                        </b-button>
                      </b-filed>
                        
                        
                  </td> 
                    
                  </tr>
                </tbody>
                
              </table>
            </div>
          </div>


          
          
          <div class="columns" >
            <div class="column">
              <div class="columns" >
                <div class="column">
                  <b-field label="ຊື່ ແລະ ນາມສະກຸນ">
                    <b-input
                      v-model.trim="selectedFullName"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns" >
                <div class="column">
                  <b-field label="ອາຍຸ">
                    <b-input
                      v-model.trim="selectedAge"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ເພດ">
                    <Multiselect     
                      placeholder="ເພດ"
                      v-model.trim="selectedGender"
                      label="NAME"
                      track-by="ID"
                      :options="genderList"   
                    ></Multiselect>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <b-field label="ພາກສ່ວນ/ ອົງການຈັດຕັ້ງ">
                    <Multiselect     
                      placeholder="ພາກສ່ວນ/ ອົງການຈັດຕັ້ງ"
                      v-model.trim="selectedSection"
                      label="NAME"
                      track-by="ID"
                      :options="selectionList"   
                    ></Multiselect>
                  </b-field>
                </div>
              </div>
              <div class="columns" >
                <div class="column">
                  <b-field label="ເບີໂທຕິດຕໍ່">
                    <b-input
                      v-model.trim="selectedPhoneNo"
                      type="text"
                    >  
                    </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="" style="margin-top: 30px;">
                    <b-button  
                        class="btn-group-margin is-fullwidth"
                        type="is-success"  
                        @click="doregister(1)"
                        >  <span > ລົງທະບຽນໃໝ່</span>
                    </b-button>
                  </b-field>
                </div>
              </div>
             
              
              
              
            </div>
              
            <div class="column">
              
            </div>
            
              
          </div>

        </b-tab-item>
        <b-tab-item label="ຕິດຕາມການເຂົ້າຮ່ວມງານ" >
          <div class="columns" v-if="participateList.length > 0">  
            <div class="column">
              <b-field grouped>
                <b-field >
                ຄົ້ນຫາ
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ຊື່ ຫຼື ນາມສະກຸນ"
                    v-model.trim="searchByFullName"
                    type="text"
                  >  
                  </b-input>
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ເບີໂທ"
                    v-model.trim="searchByPhoneno"
                    type="text"
                  >  
                  </b-input>
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ເລກລົງທະບຽນ"
                    v-model.trim="searchByRegisterID"
                    type="text"
                  >  
                  </b-input>
                </b-field>
                <b-button style="margin-top: 0px;"
                    class="btn-group-margin is-fullwidth"
                    type="is-info"  
                    @click="getParticipateDetail(data)"
                    >  <span > ຄົ້ນຫາ - {{ searchByFullName }}</span>
                </b-button>
              </b-field>
                
            </div>
          </div>
          <table class="table is-fullwidth is-narrow is-small" >
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  #
                </th>
                <th class="has-text-left " width="15%">
                  ຊື່ ແລະ ນາມສະກຸນ
                </th>
                <th class="has-text-left " width="20%">
                  ພາກສ່ວນ
                </th>
                <th class="has-text-left " width="5%">
                  ເບີໂທ
                </th>
                <th class="has-text-centered " width="20%">
                  ຈັດການ 
                </th>
                <th class="has-text-centered " width="10%">
                  ເຂົ້າຮ່ວມ
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in participateList "
                :key="data.ID"
              >
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#4FC3F7' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <span >
                    {{index + 1}}
                  </span>
                  
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#4FC3F7' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  
                  {{ data.FULLNAME }}
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#4FC3F7' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  {{ data.SECTION }}
                </td> 
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#4FC3F7' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  {{ data.PHONENO }}
                </td> 
                <td class="has-text-centered " :style="{ backgroundColor: data.STATUS== 3 ? '#4FC3F7' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <b-field>
                    <b-button 
                        class="btn-group-margin is-fullwidth"
                        type="is-primary"  
                        size="is-small"
                        >  <span > ແກ້ໄຂຂໍ້ມູນ</span>
                    </b-button>
                    <b-button  v-if="data.STATUS == 2" 
                        class="btn-group-margin is-fullwidth"
                        type="is-danger"  
                        size="is-small"  
                        >  <span > ກົດເພື່ອເຂົ້າງານ</span>
                    </b-button>
                    <b-button 
                        class="btn-group-margin is-fullwidth"
                        type="is-info"  
                        size="is-small"
                        @click="getParticipateDetail(data)"
                        >  <span > ລາຍລະອຽດ</span>
                    </b-button>
                  </b-field>
                </td> 
                <td class="centered-content"  :style="{ backgroundColor: data.STATUS== 3 ? '#4FC3F7' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <b-field grouped style="margin-left: 5px;">
                    <b-field>
                      <b-button v-if="data.STATUS == 1"   
                          class="btn-group-margin is-fullwidth"
                          type="is-success"  
                          size="is-small"
                      >
                        ກົດເພື່ອຢືນຢັນ
                      </b-button>
                    </b-field>
                      
                    <b-field v-if="data.STATUS == 2">  
                      ✅ ຕອບເຂົ້າຮ່ວມ
                    </b-field>
                    <b-field v-if="data.STATUS == 3">  
                      ✅✅ ເຂົ້າງານແລ້ວ
                    </b-field>
                      
                    <b-field v-if="data.STATUS == 0">
                      ❌ ຕອບບໍ່ເຂົ້າຮ່ວມ
                    </b-field>
                  </b-field>
                </td>
              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ" >
          <div class="columns" v-if="participateFullname">
            <div class="column">
              <div class="columns" >
                <div class="column">
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="title16">{{ participateFullname }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="title16">{{ participateAge }} </span> <span  class="title16-light">ປີ </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="title16">{{ participateGender }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ: </span><span  class="title16">{{ participateSection }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="title16">{{ participatePhoneNo }} </span>
                  </b-field>
                  <b-field v-if="participateStatus == 2" >
                    <b-button  
                          class="btn-group-margin is-fullwidth"
                          type="is-danger"  
                          >  <span > ກົດເພື່ອເຂົ້າງານ</span>
                    </b-button>
                  </b-field>

                  <b-field v-if="participateStatus == 3" class="red16bold"> 
                    ✅✅ ເຂົ້າງານແລ້ວ
                  </b-field>
                    
                  <b-field v-if="participateFullname">
                    <img :src="qrCodeUrl" alt="QR Code" />
                  </b-field>
                </div>
              
              </div>

              
              
            </div>
              
            <div class="column">
              
            </div>
            
              
          </div>
        </b-tab-item>
        
      </b-tabs>
      

      
    </div>


    

    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect },

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      selectedSection: null,
      selectionList: [
        { ID: "1", NAME: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ" },
        { ID: "2", NAME: "ກະຊວງກະສິກຳ" },
        { ID: "3", NAME: "ກະຊວງສຶກສາ" },
        { ID: "4", NAME: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ" },
      ],

      participateList: [],

      eventList: [],

      selectedEventID: null,
      selectedEventName: null, 

      event1: [
        { EVENTID: "1",ID: "1", FULLNAME: "ທ່ານ ບຸນຄອງ ທານະວັນ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "3"},
        { EVENTID: "1",ID: "2", FULLNAME: "ທ່ານ ດວງຈັນ ສີພາວັນ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ", PHONENO: "2055555555", STATUS: "2"},
        { EVENTID: "1",ID: "3", FULLNAME: "ທ່ານ ຄຳຫຼ້າ ແສງມະໂນທອງ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງກະສິກຳ", PHONENO: "2055556666" , STATUS: "2"},
        { EVENTID: "1",ID: "4", FULLNAME: "ທ່ານ ເຂັມທອງ ທຳມະຈັກ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງສຶກສາ", PHONENO: "2055557777" , STATUS: "1"},
        { EVENTID: "1",ID: "5", FULLNAME: "ທ່ານ ສົມຮັກ ສົມສີ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "0"}
      ],

      event2: [
        { EVENTID: "2",ID: "1", FULLNAME: "ທ່ານ ບຸນຄອງ ດວງບຸດດີ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "3"},
        { EVENTID: "2",ID: "2", FULLNAME: "ທ່ານ ດາວພະຈັນ ສີຫາລາດ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ", PHONENO: "2055555555", STATUS: "2"},
        { EVENTID: "2",ID: "3", FULLNAME: "ທ່ານ ຄຳຫຼ້າ ແສງມະໂນທອງ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງກະສິກຳ", PHONENO: "2055556666" , STATUS: "2"},
        { EVENTID: "2",ID: "4", FULLNAME: "ທ່ານ ເຂັມທອງ ທຳມະຈັກ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງສຶກສາ", PHONENO: "2055557777" , STATUS: "1"},
        { EVENTID: "2",ID: "5", FULLNAME: "ທ່ານ ສາຍທອງ ແກ້ວຄຳດີ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "0"}
      ],

      event3: [
        { EVENTID: "3",ID: "1", FULLNAME: "ທ່ານ ສົມປອງ ດວງດີ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "3"},
        { EVENTID: "3",ID: "2", FULLNAME: "ທ່ານ ດວງຈັນ ສີພາວັນ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ", PHONENO: "2055555555", STATUS: "2"},
        { EVENTID: "3",ID: "3", FULLNAME: "ທ່ານ ແສງຈັນ ດວງສຳພັນ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງກະສິກຳ", PHONENO: "2055556666" , STATUS: "2"},
        { EVENTID: "3",ID: "4", FULLNAME: "ທ່ານ ເຂັມທອງ ທຳມະຈັກ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງສຶກສາ", PHONENO: "2055557777" , STATUS: "1"},
        { EVENTID: "3",ID: "5", FULLNAME: "ທ່ານ ບຸນຮັກ ແສງທອງ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "0"}
      ],

      event4: [
        { EVENTID: "4",ID: "1", FULLNAME: "ທ່ານ ສາຍທອງ ສາຍສົມພູ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "3"},
        { EVENTID: "4",ID: "2", FULLNAME: "ທ່ານ ດວງຈັນ ສີພາວັນ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງອຸດສາຫະກຳ ແລະ ການຄ້າ", PHONENO: "2055555555", STATUS: "2"},
        { EVENTID: "4",ID: "3", FULLNAME: "ທ່ານ ຄຳແກ້ວ ແສງມະໂນທຳ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງກະສິກຳ", PHONENO: "2055556666" , STATUS: "2"},
        { EVENTID: "4",ID: "4", FULLNAME: "ທ່ານ ເຂັມທອງ ທຳມະຈັກ", AGE: "33", GENDER:"ຊາຍ", SECTION: "ກະຊວງສຶກສາ", PHONENO: "2055557777" , STATUS: "1"},
        { EVENTID: "4",ID: "5", FULLNAME: "ທ່ານ ແສງຈັນ ແສງມະໂນທຳ", AGE: "36", GENDER:"ຊາຍ", SECTION: "ສະມາຄົມທຸລະກິດກະສິກຳລາວ", PHONENO: "2055558888" , STATUS: "0"}
      ],

      
      selectedFullName: null,
      selectedAge: null,
      genderList:[{ID : "1", NAME: "ຊາຍ"}, {ID : "2", NAME: "ຍິງ"}] ,
      selectedGender: null,
      selectedPhoneNo: null,

      participateFullname: null,
      participateAge: null,
      participateGender: null,
      participateSection: null,
      participatePhoneNo: null,
      participateStatus: null,

      qrData: null,

      

      eventTitle: null,

      searchByFullName: null,
      searchByPhoneno: null,
      searchByRegisterID: null,

      regsiterByPhoneno: null,
      phoneNoEventList: [],
      countThisEvent: 0,
      
      
    };
     
    
  },
  methods: {     

    searchRegsiterByPhoneno(){
      var params = {
        phoneno: this.regsiterByPhoneno,
        eventid: this.selectedEventID,
        username: this.username,  
      };
      RestAPI.searchRegsiterByPhoneno(params)
        .then((res) => {
          this.selectedFullName = null;
          this.selectedAge = null;
          this.selectedGender = null;
          this.selectedSection = null;
          this.selectedPhoneNo = null;
          this.phoneNoEventList = res.data.responseData.data.list;
          this.countThisEvent = res.data.responseData.data.countthisevent;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },  
    
    registerForm(data){  
      this.regsiterByPhoneno = null;
      this.phoneNoEventList = [];
      this.countThisEvent = 0;
      this.activeTab = 1;
      this.selectedEventName = data.NAME;
      this.selectedEventID = data.ID;
      
    },


    doregister(type, registerid = null){
      console.log("type: " + type)
      if(type==1){
        if(!this.selectedFullName || this.selectedFullName === null || !this.selectedAge || this.selectedAge === null || !this.selectedGender || this.selectedGender === null || 
           !this.selectedSection || this.selectedSection === null || !this.selectedPhoneNo || this.selectedPhoneNo=== null )     {
               this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ", "", "warning");
               return false;
        }
      }

      
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
        if (result.value) {

          var params;
            if(type ==1){
              params = {
                type: type,
                registerid: registerid,
                fullname: this.selectedFullName,
                age: this.selectedAge,
                gender: this.selectedGender.ID,
                section: this.selectedSection.ID,
                phoneno: this.selectedPhoneNo,
                eventid: this.selectedEventID,
                username: this.username,  
              };
            }else if(type==2){
              params = {
                type: type,
                registerid: registerid,
                eventid: this.selectedEventID,
                username: this.username,  
              };
            }
            
            // console.log("params: "+JSON.stringify(params))  
            
            RestAPI.doregister(params) 
              .then((res) => {

              if(res.data.responseData.data=== 'Duplicate phoneno'){
                this.$swal("ເບີໂທລະສັບ ໄດ້ຖືກນຳໃຊ້ແລ້ວ, ກະລຸນາກວດຄືນ", "", "warning");
                return;
              }

              if(res.data.responseData.data=== 'Duplicate record'){
                this.$swal("ລາຍການຊ້ຳ, ກະລຸນາກວດຄືນ", "", "warning");
                return;
              }

              this.$swal({
                title: "ສຳເລັດ",
                text: "ລົງທະບຽນ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });

              this.selectedFullName = null;
              this.selectedAge = null;
              this.selectedGender = null;
              this.selectedSection = null;
              this.selectedPhoneNo = null;
              this.regsiterByPhoneno = null;
              this.phoneNoEventList= [];
              this.countThisEvent = 0;

              //getEventParticipateList

              
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
            });
        }
      });
      
    },

    getEventDetail(data){  
      this.regsiterByPhoneno = null;
      this.countThisEvent = 0;
      this.phoneNoEventList = [];
      this.activeTab = 2;
      this.selectedEventName = data.NAME;
      this.selectedEventID = data.ID;


      RestAPI.getEventDetail(data.ID)
        .then((res) => {
          this.participateList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

      // if(data.ID ==1){
      //   this.participateList = this.event1;
      // }else if(data.ID ==2){
      //   this.participateList = this.event2;
      // }else if(data.ID ==3){
      //   this.participateList = this.event3;
      // }else if(data.ID ==4){
      //   this.participateList = this.event4;
      // }

      // console.log("data: "+ JSON.stringify(data))
      
    },
    
    getParticipateDetail(data){
      this.activeTab = 3; 
      this.participateFullname = data.FULLNAME;
      this.participateAge = data.AGE;
      this.participateGender = data.GENDER;
      this.participateSection = data.SECTION;
      this.participatePhoneNo = data.PHONENO;
      this.participateStatus=  data.STATUS;

      this.qrData = data.ID + " | " + data.FULLNAME + " | " + data.SECTION;
    },
   

    getEvent() {
      RestAPI.getEvent()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.eventList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    this.username = this.user.USERNAME;   

    this.currentDate = new Date();


    this.getEvent();
    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(this.qrData)}`;
    },

    computed: {

      filteredParticipateList() {
        return this.participateList.filter((data) =>
          data.FULLNAME.toLowerCase().includes(this.searchByFullName.toLowerCase())
        );
      },

    },
  
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>
